<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/z8AfuJ/tc-custom/9781429916240.jpg?1737748695835" alt="This image is the cover for the book School of Fortune"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">School of Fortune
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A fun, fresh frolic of a novel starring a spoiled but lovable Texas heiress out to reclaim her fortune</b><br/><br/>Pippa Walker's wedding was to be huge—<i>Texas</i> huge—complete with twelve bridesmaids under contract from Pippa's mother to stay lean and long-haired, gondolas flown in from Venice, A- and B- guest lists. But when Pippa finds out her handsome husband-to-be isn't what she thought, she bolts from her own wedding, shocking society and getting herself disinherited. The only way she can get a piece of the family fortune back is to earn a degree from a school. <i>Any</i> school. It's a tough assignment for a girl who dropped out of SMU after pledging Kappa Kappa Gamma and shopping at Neiman's for a year.<br/><br/>But Pippa is nothing if not up for a challenge. Attracting one hilarious misadventure after another, she tries to earn her sheepskin at: driving school, matchmaking school, even a circus academy. It's only when she hits rock-bottom—The Mountbatten Savoy School of Household Management—that things begin to look up. But can she really be falling in love with a…valet?<br/><br/>"Great, silly fun, guaranteed to be seen at a beach near you." - <i>Kirkus Reviews</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amanda Brown, Janice Weber
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f7fb39d